import { render, staticRenderFns } from "./index_3.vue?vue&type=template&id=6c0bfc05"
import script from "./index_3.vue?vue&type=script&lang=js"
export * from "./index_3.vue?vue&type=script&lang=js"
import style0 from "./index_3.vue?vue&type=style&index=0&id=6c0bfc05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports